import { useMemo } from 'react';

import styles from '@components/Reports/AccountSnapshot/AccountSnapshotTable.module.css';

import { BootstrapTable } from '@components/Table/Table';

const renderFlagCell = ({ value }) =>
  value ? (
    <img className={styles.snapshotImgRound} src={value} alt={value} />
  ) : null;

export const AccountSnapshotTable = ({ data }) => {
  const columns = useMemo(
    () => [
      {
        id: 'flag',
        Header: '',
        Cell: renderFlagCell,
        accessor: 'country.flag_href',
        className: 'col-md-1',
      },
      { Header: 'Country', accessor: 'country.name', className: 'col-md-2' },
      {
        Header: 'Active numbers',
        accessor: 'dids_amount',
        className: 'col-md-2',
      },
      {
        Header: 'Cancellations 30 days',
        accessor: 'cancellations_30_days',
        className: 'col-md-2',
      },
      {
        Header: 'Inbound min 7 days',
        accessor: 'minutes_last_7_days.inbound',
        className: 'col-md-2',
      },
      {
        Header: 'Outbound min 7 days',
        accessor: 'minutes_last_7_days.outbound',
        className: 'col-md-2',
      },
    ],
    []
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, bordered: true })}
      headerProps={() => ({ className: 'text-center' })}
      cellProps={() => ({ className: 'text-center' })}
    />
  );
};
